import { Box, Container, HStack, useColorModeValue, VStack, Text, Image, Progress, Divider, Radio, Checkbox, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Alert, AlertIcon, useDisclosure, ModalCloseButton, Center, Input, Spinner, Select, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import DesktopNav from '../components/layout/Navbar/DesktopNav/DesktopNav';
import pagoCoin from '../components/images/pago-head.png';
import pago from '../components/images/Pago-Coin.png';
import {
    collection,
    getDocs,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    Timestamp,
    query,
    where,
    QuerySnapshot,
} from "firebase/firestore";
import { db } from '../components/firebase/FirebaseConfig';
import axios from 'axios';
import algosdk, { algosToMicroalgos, bigIntToBytes, bytesToBigInt, decodeAddress, getApplicationAddress, microalgosToAlgos } from 'algosdk';
import { useNavigate } from 'react-router-dom';
import { getAllAssetsAction, myAlgoWalletInfo, PoolAmountAction } from '../components/redux/actions';
import { rates } from '../components/UtilizationRate/UtilizationRateData';
import { API_URL } from '../url';
import { peraWallet } from "./WalletNew";
import { motion, AnimatePresence } from "framer-motion";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { toast } from "react-toastify"
import {ArrowRightIcon} from "@chakra-ui/icons";
import {NFTStorage} from "nft.storage";

//const borrowAppId = parseInt(process.env.REACT_APP_BORROW_APP_ID);

const animationVariants = {
    hidden: {
        opacity: 0,
        scale: 0,
        rotate: 0,
    },
    visible: {
        opacity: 1,
        scale: 1,
        rotate: 0,
        transition: {
            duration: 0.8,
            ease: 'backInOut',
        },
    },
    exit: {
        opacity: 0,
        scale: 0,
        rotate: 0,
        transition: {
            duration: 0.8,
            ease: 'backInOut',
        },
    },
};

function TestnetCampaignMint(props) {
    //const nftURL = 'https://bafybeicguhyiq53ju6qqpl6gl546iuvyuw55k4azovy472n6oytwf4mlcy.ipfs.dweb.link/PAGO_Driving.jpg'
    const navigate = useNavigate();
    const algoAdd = useSelector(state => state.token.myAlgoAddress);
    const algoBalance = useSelector(state => state.token.myAlgoBalance);
    const appIdFromRedux = useSelector(state => state.token.borrow_app_id);
    const walletAddress = useSelector(state => state.token.walletConnectAddress);
    const walletAmount = useSelector(state => state.token.walletConnectBalance);
    const walletConnectStatus = useSelector(state => state.token.walletConnectStatus);
    const bgColor = useColorModeValue("rgb(230, 253, 255)", "blackAlpha.200");
    const textColor = useColorModeValue("gray.600", "whiteAlpha.900");
    /*
    const [allNfts, setAllNfts] = useState([]);
    const [allNftsCollection, setAllNftsCollection] = useState([]);
    const [whiteListItem, setWhiteListItem] = useState([]);
    const nftCollectionRef1 = collection(db, "whiteListedNFT");
    const allNFTCollectionRef = collection(db, "WhiteListedNFTCollection");

     */
    const nftCollectionRef = collection(db, "nfts");
    const nftBorrowRef = collection(db, "borrow");

    //const [checkbox, setCheckBox] = useState(true);
    //const [checkBoxItem, setCheckBoxItem] = useState([]);

    const { isOpen, onOpen, onClose } = useDisclosure();
    const modal1 = useDisclosure();
    const modal2 = useDisclosure();

    /*
    const deposit_rate = useSelector(state => state.token.deposit_rate);
    const modal3 = useDisclosure();
    const modal4 = useDisclosure();
    const [item1, setItem1] = useState(false);
    const [item2, setItem2] = useState(false);
    const [item3, setItem3] = useState(false);
    const [item4, setItem4] = useState(false);
    const [item5, setItem5] = useState(false);
    const [data, setData] = useState([]);
    const [borrowAmount, setAmount] = useState(0);
    const nftDepositRef = collection(db, "deposit");
    const [totalDeposit, setDeposit] = useState();
    const [totalBorrow, setBorrow] = useState();
    const [poolAmountNew, setPoolAmountNew] = useState();
    const borrowInfoRef = collection(db, "borrow-info");
    const [borrowInfo, setBorrowInfo] = useState()
    const [checkAmount, setCheckAmount] = useState(false)
    const poolAmount = useSelector(state => state.token.pool_amount);
    const [sliderValue, setSliderValue] = useState(0);
    let totalBorrowAmount = 0;
    let totalDipositAmount = 0;
    //const [depositAccAmount, setDepositAccAmount] = useState();
     */

    const dispatch = useDispatch();
    const [option, setOption] = useState("");
    const [itemNumber, setItemNumber] = useState("");
    const [fileDataURL, setFileDataURL] = useState("https://ipfs.algonft.tools/ipfs/QmXkZDW83bhpcHkS6uiwUHWyqdppSqNL32mSuwyn1DMqgV");
    const [collectionName, setCollectionName] = useState();
    const [price, setPrice] = useState();
    const nftCloseAuctionRef = collection(db, "closeAuction");
    const [popUp, alertPopUp] = useState(false);
    const [status, setStatus] = useState(true);
    const [image, setImage] = useState(true);
    const [selectItem, setSelectItem] = useState(true);
    const [accountAddress, setAccountAddress] = useState(null);
    const [error, setError] = useState(false);
    const [canMint, setCanMint] = useState(false);
    const [mintedNfts, setMintedNfts] = useState(1);

    useEffect(() => {
        const checkMintedWallet = async () => {
            if(accountAddress) {
                const mintedWalletsRef = collection(db, "testnetCampaignNFTMintedWallet");

                // Query the collection for a document with a field accountAddress that equals to the connected wallet's address
                const q = query(mintedWalletsRef, where("accountAddress", "==", accountAddress));

                // Get the first document from the results
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    setCanMint(false);
                } else {
                    setCanMint(true);
                }
            }
        }
        checkMintedWallet();
    }, [accountAddress]);

    const handleSubmit = async () => {
        const asset_url = "ipfs://bafybeicguhyiq53ju6qqpl6gl546iuvyuw55k4azovy472n6oytwf4mlcy/PAGO_Driving.jpg";
        //console.log(asset_url);
        modal2.onOpen();
        //try {
            if(!canMint) {
                toast.error("This wallet has already minted a NFT.");
                return;
            }
            const algodClient = new algosdk.Algodv2("", 'https://mainnet-api.algonode.cloud', '');
            const suggested_params = await algodClient.getTransactionParams().do();
            const creator = process.env.REACT_APP_ADMIN_GALAPAGO_ADDRESS;
            //console.log("Creator address", creator);
            const creator_mnemonic = process.env.REACT_APP_ADMIN_GALAPAGO_ADDRESS_SECURITY_KEY;
            //console.log("Creator key", creator_mnemonic);
            const creatorPrivateKey = algosdk.mnemonicToSecretKey(creator_mnemonic);
            const receiver = accountAddress;
            const defaultFrozen = false;
            const unitName = "testnet" + mintedNfts;
            const assetName = "Galapago Testnet NFT"
            //console.log("===============", assetName);
            //const price = selectItem.floor_price / 1000;
            const url = asset_url;
            //console.log("+++++++++", url)
            const managerAddr = accountAddress;
            const reserveAddr = accountAddress;
            const freezeAddr = accountAddress;
            const clawbackAddr = accountAddress;
            const total = 1;                // NFTs have totalIssuance of exactly 1
            const decimals = 0;             // NFTs have decimals of exactly 0
            // const asset = check ? otherFile : url;
            // const asset = check ? asset_url2 : asset_url;
            const d = new Date();
            ////console.log("Pera Wallet connection check 2 ", peraWallet.isConnected, peraWallet.platform);

            const txn = algosdk.makeAssetCreateTxnWithSuggestedParamsFromObject({
                from: creator,
                total,
                decimals,
                assetName,
                unitName,
                assetURL: url,
                assetMetadataHash: undefined,
                defaultFrozen,
                freeze: freezeAddr,
                manager: managerAddr,
                clawback: clawbackAddr,
                reserve: reserveAddr,
                suggestedParams: suggested_params,
            });
            // Sign the transaction
            let signedTxn = txn.signTxn(creatorPrivateKey.sk);
            // Send the transaction
            let sendTx = await algodClient.sendRawTransaction(signedTxn).do();
            // Wait for confirmation
            let confirmedTxn = await algosdk.waitForConfirmation(algodClient, sendTx.txId, 4);
            console.log("Confirmed transaction with txID: ", sendTx.txId);
            // Get the asset id from the confirmed transaction
            let nftID = confirmedTxn["asset-index"];
            console.log("Asset ID: ", nftID);

            // Create the asset opt-in transaction
            const suggestedParams = await algodClient.getTransactionParams().do();

            const optInTxn = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
                from: accountAddress,
                to: accountAddress,
                suggestedParams,
                assetIndex: nftID,
                amount: 0,
            });

            modal2.onClose();
            // Sign the opt-in transaction
            const optInTxnGroup = { txn: optInTxn, signers: [accountAddress] };
            const optInTxnSignature = await peraWallet.signTransaction([[optInTxnGroup]]);
            // Send the opt-in transaction
            const txnResponse = await algodClient.sendRawTransaction(optInTxnSignature).do();


            // Now create the asset transfer transaction
            const params = await algodClient.getTransactionParams().do();

            let txnNftTransfr = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
                from: creator,
                suggestedParams: params,
                to: receiver,
                amount: 1,
                assetIndex: nftID,
            });

            modal2.onOpen();
            // Sign the transaction
            let signedTxnTransfer = txnNftTransfr.signTxn(creatorPrivateKey.sk);
            // Send the transaction
            let sendTxTransfer = await algodClient.sendRawTransaction(signedTxnTransfer).do();
            // Wait for confirmation
            await algosdk.waitForConfirmation(algodClient, sendTxTransfer.txId, 4);
            console.log("Confirmed transfer of the asset with txID: ", sendTxTransfer.txId);

            /*
            const singleTxnGroups = [{txn: txn, signers: [creator]}];
            const signedTxn = await peraWallet.signTransaction([singleTxnGroups]);
            // //console.log(signedTxn); return 0;
            const response = await algodClient.sendRawTransaction(signedTxn).do();

             */

            setMintedNfts(prevCount => prevCount + 1);  // update mintedNfts count
            const mintedWalletsRef = collection(db, "testnetCampaignNFTMintedWallet");

            // Create a new document with an auto-generated ID
            const docRef = await addDoc(mintedWalletsRef, {accountAddress: accountAddress});

            console.log("Document written with ID: ", docRef.id);

            setCanMint(false);

            alertPopUp(true);
            ////console.log();
            modal2.onClose();
            toast.success("NFT Minted Successfully")
            setTimeout(() => {

                alertPopUp(false);
                //navigate("/single", { state: { nft: true, name: assetName, price: price, url: url, total: total, address: algoAdd, option: option, assetID: assetID, type: "" } });
            }, 3000);

        /*
        } catch (error) {
            modal2.onClose();
            toast.error("Something went wrong !!!")
        }

         */
    }
    function handleDisconnectWalletClick() {
        peraWallet.disconnect();
        setAccountAddress(null);
        setCanMint(false);
    }
    async function handleConnectWalletClick() {
        onClose();
        peraWallet
            .connect()
            .then(async (newAccounts) => {
                peraWallet.connector?.on("disconnect", handleDisconnectWalletClick);
                const address = newAccounts[0];

                setAccountAddress(address);
                // Check if address is already in the collection
                const mintedWalletsRef = collection(db, "testnetCampaignNFTMintedWallet");
                const q = query(mintedWalletsRef, where("accountAddress", "==", address));
                const querySnapshot = await getDocs(q);
                if (querySnapshot.empty) {
                    setCanMint(true);
                } else {
                    setCanMint(false);
                }

            })
            .catch((error) => {
                onOpen();
                if (error?.data?.type !== "CONNECT_MODAL_CLOSED") {
                    setError(true);
                    console.error("Error connecting wallet", error);
                }
            });
    }

    return (
        <>
            <Box zIndex="100" top="0" position="fixed" width="100%">{walletConnectStatus ? <DesktopNav name={walletAddress} amount={walletAmount} /> : <DesktopNav name={algoAdd} amount={algoBalance} />}</Box>

            <Box minH="100vh" py="50px">

                <Box w="100%" mt="70px">
                    <Container maxW={'3xl'} borderRadius="20px" boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" pb="20px">
                        <HStack alignItems="center" justifyContent="space-between" justifyItems="center" px="20px" py="30px">
                            <VStack align="left">
                                <Text fontSize="30px" fontWeight="600" mb="-5px">Project Galapago Testnet Campaign NFT Mint</Text>

                            </VStack>

                            <Image src={pagoCoin} h="50px" w="50px" />
                        </HStack>
                        <Stack
                            direction="row"
                            spacing="24px"
                            marginTop="24px"
                            alignItems="center"
                            justifyContent="center"
                            width="100%"
                        >
                            <Button
                                leftIcon={<ArrowRightIcon />}
                                bgGradient='linear(to-r, #85BF47, #38B455)'
                                color="whiteAlpha.900"
                                _hover={{ bgGradient: 'linear(to-r, #38B455, #85BF47)' }}
                                py="25px"
                                width="300px"
                                onClick={handleConnectWalletClick}
                                borderRadius="12px"
                            >
                                Connect with Pera Wallet
                            </Button>
                            {accountAddress && canMint && (
                            <Button
                                bgGradient='linear(to-r, #85BF47, #38B455)'
                                color="whiteAlpha.900"
                                _hover={{ bgGradient: 'linear(to-r, #38B455, #85BF47)' }}
                                type="submit"
                                py="25px"
                                width="300px"
                                onClick={handleSubmit}
                                borderRadius="12px"
                            >
                                Mint
                            </Button>
                                )}
                        </Stack>

                    </Container>
                </Box>
            </Box>

            {/* ==================Loader Modal====================== */}
            <Modal isOpen={modal2.isOpen} onClose={onClose} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Creating NFT.....</ModalHeader>
                    <ModalBody alignItems="center" py="20px">
                        <HStack alignItems="center" justifyContent="space-evenly">
                            <Spinner
                                thickness='4px'
                                speed='0.65s'
                                emptyColor='gray.200'
                                color='blue.500'
                                h="120px"
                                w="120px"
                            />
                        </HStack>
                    </ModalBody>
                </ModalContent>
            </Modal>
            {/* ==================Loader Modal ends================= */}


        </>
    )
}

export default TestnetCampaignMint

